
    var riot = require('riot')
    import * as constant from '@common/constant';
riot.tag2('login', '<form class="pure-form pure-form-stacked" onsubmit="{formSubmit}"> <input type="text" name="dummyemail" autocomplete="email" style="top: -100px; left: -100px; position: fixed;"> <input type="password" name="dummypass" autocomplete="current-password" style="top: -100px; left: -100px; position: fixed;"> <div class="kf-form-group"> <label for="mail">メールアドレス</label> <input class="pure-input-1" id="mail" ref="mail" required type="email"> </div> <div class="kf-form-group"> <label for="password">パスワード</label> <input class="pure-input-1" type="password" id="password" ref="password"> </div> <div class="kf-form-group"> <label for="checkPassword"> <input type="checkbox" onchange="{checkPassword}" id="checkPassword"> <small>パスワードを表示する</small> </label> </div> <div class="kf-form-group"> <label for="save-input-check"> <input id="save-input-check" type="checkbox" ref="saveInputCheck" checked> <small>入力内容を保存する</small> </label> </div> <button class="pure-button pure-button-success kf-block">ログイン</button> </form> <div class="link"> <a href="#register">新規登録</a> <a href="#password">パスワードを忘れた場合</a> </div>', '', '', function(opts) {
    this.mixin('password');

    this.formSubmit = (e) => {
      e.preventDefault();
      document.querySelector('[name=dummyemail]').value = '';
      this.action
        .login({
          mail: this.refs.mail.value,
          password: this.refs.password.value,
          saveInputCheck: this.refs.saveInputCheck.checked
        });
    };

    this.on('mount', () => {
      this.refs.mail.value = atob(localStorage.getItem(constant.MAIL_KEY) || '');
      this.refs.password.value = atob(localStorage.getItem(constant.PASS_KEY) || '');
    });
});
    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('login')
    }
  }
  